/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * MissingJWKSURLError class.
 */
export class MissingJWKSURLError extends Error {
  constructor(oidcProviderURL: string | null) {
    super(`OpenID Provider ${oidcProviderURL} has no a JWKS URL.`);
  }
}

/**
 * UnreachableURIError class.
 */
export class UnreachableURIError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UnreachableURIError";
  }
}

/**
 * UnreachableOpenIDProviderURIError class.
 */
export class UnreachableOpenIDProviderURIError extends UnreachableURIError {
  constructor(openIDProviderURL: string | null) {
    super(`OpenID provider ${openIDProviderURL} is unreachable.`);
    this.name = "UnreachableOpenIDProviderURIError";
  }
}

/**
 * UnreachableJWKSURIError class.
 */
export class UnreachableJWKSURIError extends UnreachableURIError {
  constructor(jwksURI: string | null) {
    super(`JWKS URI ${jwksURI} is unreachable.`);
    this.name = "UnreachableJWKSURIError";
  }
}

/**
 * EmptyJWKSError class.
 */
export class EmptyJWKSError extends Error {
  constructor() {
    super("Unable to find a signing key that matches the provided token.");
    this.name = "EmptyJWKSError";
  }
}
